import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "explanation-screen" }
const _hoisted_2 = {
  key: 0,
  class: "explanation-container"
}
const _hoisted_3 = { class: "explanation-title" }
const _hoisted_4 = ["innerHTML"]

import Question from "../models/Question"
import markdownParser from "../../../helpers/markdown-parser"
import SkillPreviewComponent from './SkillPreviewComponent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExplanationPreviewComponent',
  props: {
    groupQuestions: {}
  },
  setup(__props: any) {



const getContent = (question: Question): string => {
  return markdownParser(question.description)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.groupQuestions && __props.groupQuestions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupQuestions, (question, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: question.id || index
            }, [
              _createElementVNode("h3", _hoisted_3, "解説" + _toDisplayString(__props.groupQuestions.length > 1 ? (index + 1) : ''), 1 /* TEXT */),
              _createVNode(SkillPreviewComponent, { question: question }, null, 8 /* PROPS */, ["question"]),
              _createElementVNode("div", {
                class: "explanation-preview-content",
                innerHTML: getContent(question)
              }, null, 8 /* PROPS */, _hoisted_4)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})